import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faPlus,
  faPlusSquare,
  faMinusSquare,
  faMinus,
  faDollar,
  faUpRightFromSquare,
  faUpRightAndDownLeftFromCenter,
  faSquareArrowUpRight,
  faSquareCheck,
  faFilePen,
  faFileLines,
  faComment,
  faCommenting,
  faComments,
  faDollarSign,
  faMoneyBills,
  faBars,
  faUser,
  faHome,
  faHouseUser,
  faLock,
  faSignOutAlt,
  faCog,
  faArrowAltCircleRight,
  faFilePdf,
  faSpinner,
  faChevronRight,
  faChevronLeft,
  faChevronUp,
  faChevronDown,
  faEdit,
  faUserEdit,
  faTimes,
  faChild,
  faChildren,
  faCheck,
  faCheckDouble,
  faSave,
  faSquare,
  faCheckSquare,
  faCheckCircle,
  faEnvelopeSquare,
  faEnvelope,
  faEnvelopeOpen,
  faInfo,
  faInfoCircle,
  faCircleXmark,
  faTriangleCircleSquare,
  faTriangleExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faImage,
  faImages,
  faImagePortrait,
  faGlobe,
  faGlobeEurope,
  faEarth,
  faEarthEurope,
  faGlobeAmericas,
  faGlobeOceania,
  faGlobeAfrica,
  faNewspaper,
  faCogs,
  faUserCog,
  faUsersCog,
  faExternalLinkSquare,
  faExternalLink,
  faExternalLinkAlt,
  faStar,
  faFlag,
  faHomeAlt,
  faHouseFlag,
  faScissors,
  faCut,
  faCopy,
  faSort,
  faSortAsc,
  faSortDesc,
  faEye,
  faEyeDropper,
  faEyeLowVision,
  faReply,
  faReplyAll,
  faPaperclip,
  faSignal,
  faSearch,
  faSearchDollar,
  faUsers,
  faUserAlt,
  faTrash,
  faTrashAlt,
  faTrashCan,
  faFolderPlus,
  faFolderMinus,
  faUserFriends,
  faPeopleGroup,
  faPeopleArrows,
  faClock,
  faUserClock,
  faShare,
  faShareSquare,
  faBuildingColumns,
  faBank,
  faBuildingFlag,
  faBuildingShield,
  faBullhorn,
  faFileImage,
  faMoneyBillTrendUp, faMoneyBillTransfer
} from '@fortawesome/free-solid-svg-icons'

import { faBuilding, faFolder } from '@fortawesome/free-regular-svg-icons'
import {
  faGithub, faFacebook, faLinkedin, faLinkedinIn, faFacebookSquare, faFacebookMessenger, faGoogle, faGooglePlus, faGooglePlusG, faWhatsapp, faWhatsappSquare, faTwitter, faTwitterSquare, faYoutube,
  faXTwitter, faSquareXTwitter, faStripe, faStripeS
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faPlus, faPlusSquare, faMinusSquare, faMinus, faDollar, faUpRightFromSquare, faUpRightAndDownLeftFromCenter, faSquareArrowUpRight, faSquareCheck, faFilePen, faFileLines, faComment, faCommenting, faComments, faDollarSign, faMoneyBills,
  faBars, faUser, faHome, faHouseUser, faLock, faSignOutAlt, faCog, faArrowAltCircleRight, faFilePdf, faSpinner, faChevronRight, faChevronLeft, faChevronUp, faChevronDown, faEdit, faUserEdit, faTimes, faChild, faChildren, faCheck, faCheckDouble,
  faSave, faSquare, faCheckSquare, faCheckCircle, faEnvelopeSquare, faEnvelope, faEnvelopeOpen, faInfo, faInfoCircle, faCircleXmark, faTriangleCircleSquare, faTriangleExclamation, faExclamationCircle, faExclamationTriangle,
  faImage, faImages, faImagePortrait, faGlobe, faGlobeEurope, faEarth, faEarthEurope, faGlobeAmericas, faGlobeOceania, faGlobeAfrica, faNewspaper, faCogs, faUserCog, faUsersCog, faExternalLinkSquare, faExternalLink, faExternalLinkAlt,
  faGithub, faFacebook, faLinkedin, faLinkedinIn, faFacebookSquare, faFacebookMessenger, faGoogle, faGooglePlus, faGooglePlusG, faWhatsapp, faWhatsappSquare, faTwitter, faYoutube, faTwitterSquare, faSearch, faSearchDollar,
  faStar, faFlag, faHomeAlt, faHouseFlag, faScissors, faCut, faCopy, faSort, faSortAsc, faSortDesc, faEye, faEyeDropper, faEyeLowVision, faXTwitter, faSquareXTwitter, faReply, faReplyAll, faPaperclip, faSignal, faUsers, faUserAlt, faTrash, faTrashAlt, faTrashCan,
  faStripe, faStripeS, faFolder, faFolderPlus, faFolderMinus, faUserFriends, faPeopleGroup, faPeopleArrows, faClock, faUserClock, faShare, faShareSquare, faBuildingColumns, faBank, faBuildingFlag, faBuildingShield, faBuilding, faBullhorn,
  faFileImage,faMoneyBillTrendUp, faMoneyBillTransfer
)

export default library

